<template>
  <div class="flex flex-col sm:flex-row ">
    <div class="w-full sm:w-1/3 mt-16 sm:pr-5">
      <ul
        class="level-list mb-5"
        v-if="
          purchaseData.is_already_paid != 1 ||
            (purchaseData.is_already_paid == 1 && [].length == 0)
        "
      >
        <li v-for="(level, levelIndex) in usersArray" :key="levelIndex">
          <h5>Level {{ level.levelName }}</h5>
          <div class="col-11 ml-auto px-0">
            <div
              v-for="(singleUser, userIndex) in level.level"
              :key="'user' + userIndex"
              class="d-flex align-items-center py-2 border-bottom"
            >
              <div
                v-if="
                  singleUser.purchase_map_status == 1 ||
                    singleUser.purchase_map_status == 6
                "
                class="d-flex align-items-center"
              >
                <div class="mr-3">
                  <img
                    src="@/assets/images/icons/approved-tick.svg"
                    height="30"
                    width="30"
                  />
                </div>

                <div>{{ singleUser.description }}</div>
              </div>

              <!-- REJECTED USER -->
              <div
                v-if="singleUser.purchase_map_status == 2"
                class="d-flex align-items-center"
              >
                <div class="mr-3">
                  <img
                    src="@/assets/images/icons/approval-rejected.svg"
                    height="30"
                    width="30"
                  />
                </div>

                <div>{{ singleUser.description }}</div>
              </div>

              <!-- PENDING USER -->
              <div
                v-if="singleUser.purchase_map_status == 0"
                class="d-flex align-items-center"
              >
                <div class="mr-3">
                  <img
                    src="@/assets/images/icons/approval-pending.svg"
                    height="30"
                    width="30"
                  />
                </div>
                <span>
                  {{ singleUser.description }}
                </span>
                <div
                  v-if="
                    UserRole != 'Admin' &&
                      (loggedInUser.user_id == singleUser.user_id ||
                        purchaseMapData.adminManagerArray.filter(
                          (u) => u == loggedInUser.user_id
                        ).length > 0 ||
                        (singleUser.user_level > loggedInUser.user_level &&
                          UserRole.includes('User')))
                  "
                  @click="() => showActionPopup(singleUser)"
                  class="ml-2"
                >
                  <feather-icon
                    icon="CheckCircleIcon"
                    class="cursor-pointer text-success"
                    svgClasses="h-8 w-8"
                  />
                </div>
                <div
                  v-if="
                    UserRole != 'Admin' &&
                      (loggedInUser.user_id == singleUser.user_id ||
                        purchaseMapData.adminManagerArray.filter(
                          (u) => u == loggedInUser.user_id
                        ).length > 0)
                  "
                  @click="() => showActionPopup(singleUser, 'REJECT')"
                  class="ml-2"
                >
                  <feather-icon
                    icon="XCircleIcon"
                    class="cursor-pointer text-danger"
                    svgClasses="h-8 w-8"
                  />
                </div>
              </div>
              <!-- NOT YET REACHED TO USER -->
              <div v-if="singleUser.purchase_map_status == 3" class="d-flex">
                <div class="mr-3">
                  <img
                    src="@/assets/images/icons/approval-pending.svg"
                    height="30"
                    width="30"
                    v-if="singleUser.user_id != singleUser.puserid"
                  />
                </div>
                {{
                  singleUser.user_id == singleUser.puserid
                    ? "Created By "
                    : "Not Yet Reached "
                }}&nbsp;
                <span class="font-weight-bold">
                  {{ singleUser.user_name }}
                </span>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <div v-if="purchaseData.is_verified == 1">
        <h6>Verified By : {{ purchaseMapData.user_verifier_name }}<br /></h6>
        <h6>
          Verified Date : {{ purchaseMapData.purchase_verified_date }}<br />
        </h6>
        <h6>Comment : {{ purchaseMapData.user_verifier_reason }}<br /></h6>
        <vs-button
          type="filled"
          @click="() => showActionPopup(singleUser, 'UNVERIFY')"
          class="mr-3"
        >
          Un-Verify Expense
        </vs-button>
      </div>
      <div
        v-else-if="
          purchaseData.is_verified == 0 && purchaseData.user_is_verifier
        "
      >
        <vs-button
          type="filled"
          @click="() => showActionPopup(singleUser, 'VERIFY')"
          class="mr-3"
        >
          Verify Expense
        </vs-button>
      </div>
    </div>
    <div class="w-full sm:w-2/3">
      <ForeignExpenseForm
        :form_title="'Update Foreign Remittance'"
        :is_var="purchaseData.is_var"
        :formData="purchaseData"
      />
    </div>

    <vs-popup
      v-if="actionPopup"
      :title="currentAction"
      :active.sync="actionPopup"
      style="z-index: 99999 !important;"
      @close="closeActionPopup"
    >
      <div class="text-center">
        <h5>{{ actionHeading }}</h5>
        <div class="vx-row mt-5">
          <div class="vx-col w-full">
            <vs-textarea
              counter="240"
              v-model="actionComment"
              class="mb-4"
              rows="4"
            />
            <vs-button
              color="success"
              type="filled"
              class="mr-3"
              @click="takeAction"
            >
              Submit
            </vs-button>

            <vs-button color="danger" type="filled" @click="closeActionPopup">
              Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
// Components
import ForeignExpenseForm from "./ForeignExpenseForm.vue";

// Services
import purchaseOrderService from "@/services/purchaseOrderService.js";
import projectService from "@/services/projectService.js";
import CurrencyService from "@/services/currencyService.js";
import ShootLocationService from "@/services/shootLocationService.js";
import ContractService from "@/services/ContractService.js";
import CountryService from "@/services/countryService.js";

// other imports
import PermissionVariables from "@/services/UserManagementVaraibles.js";

export default {
  components: { ForeignExpenseForm },

  props: {
    purchaseData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      purchaseMapData: null,
      usersArray: [],
      actionPopup: false,
      currentAction: "",
      actionComment: "",
      actionHeading: "",

      loggedInUser: {},
      UserRole: localStorage.getItem("UserRole") || null,
      permissionPageAccessArry: window.localStorage.getItem(
        "permissionPageAccess"
      )
        ? localStorage.getItem("permissionPageAccess").split(",")
        : "",

      projects: [],
      alternateOrg: [],
      currencyList: [],
      shootLocationList: [],
      countryList: [],
    };
  },

  methods: {
    showActionPopup(user, type = "ACCEPT") {
      this.actionPopup = true;
      this.currentAction = type;

      if (type === "ACCEPT") {
        this.actionHeading = "Reason For Accepting";
      } else if (type === "REJECT") {
        this.actionHeading = "Reason For Rejecting";
      } else if (type === "VERIFY") {
        this.actionHeading = "Reason For Verifying";
      } else if (type === "UNVERIFY") {
        this.actionHeading = "Reason For Un-Verifying";
      } else if (type === "RESUBMIT") {
        this.actionHeading = "Reason For Resubmitting";
      }
    },
    closeActionPopup() {
      this.actionPopup = false;
      this.actionComment = "";
      this.actionHeading = "";
    },
    takeAction() {
      if (this.currentAction === "ACCEPT") {
        this.approvePurchase();
      }
      if (this.currentAction === "REJECT") {
        this.rejectPurchase();
      }
    },
    getPurchaseMapDetails() {
      this.$vs.loading();
      let payload = {
        is_var: this.purchaseData.is_var,
      };

      purchaseOrderService
        .getPurchaseOrderMaping(this.purchaseData.purchase_id, payload)
        .then((response) => {
          this.$vs.loading.close();
          const { data } = response;
          if (data.Status) {
            this.purchaseMapData = data;
            this.usersArray = [];
            this.purchaseMapDetails = data.data;

            let ModArray = data.data.filter(({ mod }) => String(mod) === "1");

            let otherArray = data.data
              .filter(({ mod, user_level }) => {
                return (
                  String(mod) !== "1" &&
                  (String(mod) !== "0" || String(user_level) !== "0")
                );
              })
              .reverse();

            this.mod_user = ModArray.length > 0 ? ModArray : this.mod_user;

            let AdminArray = data.data.filter(
              ({ mod, user_level }) => String(mod) === "2"
            );

            this.admin_user =
              AdminArray.length > 0 ? AdminArray : this.admin_user;
            this.loggedInUser.user_id = data.loggedInUserId;
            this.loggedInUser.user_level = data.user_level;
            let levelGroup = _.groupBy(otherArray, "user_level");
            let reverse = Object.keys(levelGroup).reverse();
            this.usersArray = [];
            reverse.map((x) => {
              this.usersArray.push({
                levelName: x,
                level: levelGroup[parseInt(x)],
              });
            });
            for (let i = 0; i < this.usersArray.length; i++) {
              for (let j = 0; j < this.usersArray[i].level.length; j++) {
                if (
                  window.localStorage.getItem("user_id") ==
                    this.usersArray[i].level[j].user_id &&
                  (this.usersArray[i].level[j].purchase_map_status == 1 ||
                    this.usersArray[i].level[j].purchase_map_status == 2) &&
                  this.usersArray[i].level[j].is_admin_manager_user == 0
                ) {
                  this.disableUserLevelEdit = true;
                  break;
                }
              }
            }
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
    approvePurchase() {
      let obj = {
        project_id: this.purchaseData.project_id,
        purchase_id: this.purchaseData.purchase_id,
        user_id: this.loggedInUser.user_id,
        reason: this.actionComment,
      };
      purchaseOrderService
        .approvePurchaseOrderDashboard(obj)
        .then((response) => {
          const { data } = response;
          if (data.Status) {
            this.getPurchaseMapDetails();
            this.closeActionPopup();
            this.$vs.notify({
              title: "Success",
              text: data.Message,
              iconPack: "feather",
              icon: "check_box",
              color: "success",
            });
          } else {
            this.$vs.notify({
              title: "Opps!",
              text: data.Message,
              iconPack: "feather",
              icon: "check_box",
              color: "warning",
            });
          }
        });
    },
    rejectPurchase() {
      let obj = {
        project_id: this.purchaseData.project_id,
        purchase_id: this.purchaseData.purchase_id,
        user_id: this.loggedInUser.user_id,
        reason: this.actionComment,
      };
      purchaseOrderService
        .rejectPurchaseOrderDashboard(obj, { reason: this.actionComment })
        .then((response) => {
          const { data } = response;
          if (data.Status) {
            this.getPurchaseMapDetails();
            this.closeActionPopup();
            this.$vs.notify({
              title: "Success",
              text: data.Message,
              iconPack: "feather",
              icon: "check_box",
              color: "success",
            });
          } else {
            this.$vs.notify({
              title: "Opps!",
              text: data.Message,
              iconPack: "feather",
              icon: "check_box",
              color: "warning",
            });
          }
        });
    },
    getProjectsList: function() {
      console.log("Running get projects");
      this.projects = [];
      this.alternateOrg = [];
      projectService
        .getAllProjects(null, 1)
        .then((response) => {
          const { data } = response;
          console.log("data => ", data);
          if (data.Status) {
            console.log("reached inside");
            if (
              !this.permissionPageAccessArry.includes(
                PermissionVariables.ViewOrganizationProjects
              ) &&
              this.UserRole != "Admin"
            ) {
              data.data.map((x) => {
                if (
                  this.permissionPageAccessArry.includes("2P" + x.project_id)
                ) {
                  this.projects.push(x);
                }
              });
            } else {
              this.projects = data.data;
            }

            if (data.alternateOrgNew.length > 0) {
              this.alternateOrg = data.alternateOrgNew;
            } else {
              this.alternateOrg = [];
            }
          }
        })
        .catch((error) => {
          console.error("Error : ", error.message);
        });
    },
    getCurrencyList: function() {
      CurrencyService.getCurrency()
        .then((response) => {
          if (response.data.Status) {
            this.currencyList = response.data.data;
          }
        })
        .catch((error) => {
          console.error("Error : ", error.message);
        });
    },
    getShootLocationList: function() {
      ShootLocationService.getActiveShootLocation()
        .then((response) => {
          if (response.data.Status) {
            this.shootLocationList = response.data.data;
          }
        })
        .catch((error) => {
          console.error("Error : ", error.message);
        });
    },
    getCountryList: function() {
      CountryService.getCountry()
        .then((response) => {
          if (response.data.Status) {
            this.countryList = response.data.data;
          }
        })
        .catch((error) => {
          console.error("Error : ", error.message);
        });
    },
  },

  beforeMount() {
    this.getProjectsList();
    this.getCurrencyList();
    this.getShootLocationList();
    this.getCountryList();
    this.getPurchaseMapDetails();
  },
};
</script>

<style></style>
